import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetOpenTickets = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/awaiting/reopening", {
        data,
      }),
  });
export const useUpdateTicketStatus = () =>
  useMutation({
    mutationFn: (data) =>
      client("tickets/update/status", {
        data,
        successMessage: "Tickets has been updated successfully",
      }),
  });
